import axios from '../../axios'

/*
 * 材料数据接口
 */
// 获取爬虫公众号文章分页列表
export const getAccountsArticleList = (data) => {
    return axios({
        url: '/api/base/official/accounts/article/page',
        method: 'get',
        data
    })
}

// 公众号文章id查询
export const getAccountsArticleId = (data) => {
    return axios({
        url: '/api/base/official/accounts/article/get',
        method: 'get',
        data
    })
}

// 文章导出
export const accountsarticleExport = (data) => {
    return axios({
        url: '/api/base/official/accounts/article/export',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/reptile/accarticle.js